import { COOKIE_PREFERENCES_TRIGGER_ID } from "@/app/config/cookie-consent";

/** Rotas isoladas que não devem carregar o banner BeCompliance (ex.: embed em outro site). */
export const PATHS_WITHOUT_COOKIE_CONSENT = [
	"/jeep-programa-indicacao",
	"/ram-programa-indicacao",
	"/mercedes-programa-indicacao",
	"/move-brasil-jeep",
	"/jeep-avenger",
] as const;

export function isPathWithoutCookieConsent(pathname: string): boolean {
	if (pathname.startsWith("/cms")) return true;
	return (PATHS_WITHOUT_COOKIE_CONSENT as readonly string[]).includes(
		pathname,
	);
}

/** Remove UI do CMP já injetada (ex.: navegação client-side a partir de outra página). */
export function dismissCookieConsentUi() {
	if (typeof document === "undefined") return;

	[
		"#cc-main",
		"#onetrust-banner-sdk",
		"#onetrust-consent-sdk",
		"#onetrust-pc-sdk",
		".onetrust-pc-dark-filter",
		"#ot-sdk-btn-floating",
	].forEach((selector) => {
		document.querySelectorAll(selector).forEach((el) => el.remove());
	});

	document.body.classList.remove("ot-sdk-show", "onetrust-body-overflow");
	document.documentElement.classList.remove("ot-sdk-show");
	document.body.style.removeProperty("overflow");

	const win = window as Window & { OneTrust?: { Close?: () => void } };
	win.OneTrust?.Close?.();
}

type CookieConsentApi = {
	showPreferences?: () => void;
};

/** Abre o modal "Quem pode usar seus cookies?" da BeCompliance. */
export function showCookiePreferencesModal() {
	if (typeof window === "undefined") return;

	const api = (window as Window & { CookieConsent?: CookieConsentApi })
		.CookieConsent;

	if (typeof api?.showPreferences === "function") {
		api.showPreferences();
		return;
	}

	document.getElementById(COOKIE_PREFERENCES_TRIGGER_ID)?.click();
}
